import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';

import type { IListResponse } from '../../../core/models/responses.models';
import type { IProject } from '../../../project/models';
import { ApiProjectsService } from '../../../project/services/api/api-projects.service';
import type { UserCounts } from '../../models/user';
import { ApiUserService } from '../../services/api-user.service';
import { checkProjectsExistence, checkProjectsExistenceSuccess, setUserCounts, setUserCountsSuccess } from './user-info.actions';
import { CurrentUserService } from '../../services/current-user.service';

@Injectable()
export class UserInfoEffects {
  private apiProjects = inject(ApiProjectsService);
  private currentUser = inject(CurrentUserService);
  private apiUser = inject(ApiUserService);

  private readonly actions$ = inject<Actions>(Actions);
  checkProjectsExistence$ = createEffect(() =>
    this.actions$.pipe(
      ofType(checkProjectsExistence),
      switchMap(() =>
        this.apiProjects
          .getProjects({
            page: 1,
            page_size: 1,
            owner: this.currentUser.user.id,
          })
          .pipe(map((res: IListResponse<IProject>) => checkProjectsExistenceSuccess({ hasProjects: Boolean(res.count) }))),
      ),
    ),
  );
  getUserCounts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setUserCounts),
      switchMap(() => this.apiUser.getUserCounts().pipe(map((res: UserCounts) => setUserCountsSuccess({ counts: res })))),
    ),
  );
}
